var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.347,
    height: 50,
    viewBox: "0 0 37.347 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "water",
    transform: "translate(-134 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(134 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M151.089-500.4c-9.365,9.56-15.35,18.964-16.864,26.454a13.589,13.589,0,0,0-.225,3.31,14.527,14.527,0,0,0,.684,5.166,18.865,18.865,0,0,0,7.47,10.243,18.675,18.675,0,0,0,23.973-2.529,18.521,18.521,0,0,0,4.892-9.3,19.323,19.323,0,0,0-.078-7.48c-1.514-7.1-7.617-16.581-16.484-25.623L152.651-502Zm4.365,5.839a80.024,80.024,0,0,1,8.593,11.571c3.164,5.391,4.482,9.668,4.169,13.5A15.443,15.443,0,0,1,163.968-460a15.962,15.962,0,0,1-8.584,4.658,19.71,19.71,0,0,1-5.468,0,15.769,15.769,0,0,1-12.548-12.147,15.506,15.506,0,0,1,0-6.289c1.318-6.044,6.279-14.022,13.9-22.333l1.377-1.5.869.918C153.989-496.19,154.868-495.233,155.454-494.559Z",
    transform: "translate(-134 502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M255.52,99.99a11.855,11.855,0,0,0,.551,3.121,12.67,12.67,0,0,0,7.8,8.1,16.043,16.043,0,0,0,3.4.7l.758.069v-3.13l-.975-.109a9.518,9.518,0,0,1-7.748-5.877,11.5,11.5,0,0,1-.679-2.944l-.059-.561H255.52v.63Z",
    transform: "translate(-249.345 -68.836)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.ff086af16112729612e04c7e521abcee.svg";
export { ForwardRef as ReactComponent };